import script from "./RecopilarDatosPN2.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecopilarDatosPN2.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__